/**
 * The splash that `index.html` draws before any script loads (owner, 2026-11-03, option B of canvas
 * "AttireRent Loader & Splash"): the app icon opening out to fill the window.
 *
 * <p>
 * It is written inline there because it has to paint before the bundle arrives. This takes it away
 * once the app has rendered, never before the opening has played. It plays only the first time in a
 * tab: on a reload the inline script marks it `is-quiet`, the plain band until the app draws, so a
 * clerk pressing F5 at the counter never waits for it and never sees a white flash.
 * </p>
 */

/** How long the opening in `index.html` runs, counted from the start of the page. */
export const bootSplashOpensFor = 1400;

/** The fade in `index.html`. If `transitionend` never fires, the timer still removes the element. */
const fadeFor = 300;

export function hideBootSplash(now = performance.now()) {
  const splash = document.getElementById('boot-splash');

  if (!splash) {
    return;
  }

  window.setTimeout(
    () => {
      splash.classList.add('is-done');
      window.setTimeout(() => splash.remove(), fadeFor);
    },
    splash.classList.contains('is-quiet') ? 0 : Math.max(0, bootSplashOpensFor - now),
  );
}
